import React from "react";
import PropTypes from "prop-types";
import { formatPeriodLabel } from "./formatPeriod.js";

/**
 * CoverPage - the first page of an A4 board report: centered title, an
 * optional italic subtitle, an optional confidentiality badge, the period, an
 * optional logo, and a meta line carrying the report owner and generated-on
 * timestamp.
 *
 * subtitle/confidentiality/reportOwner come from the board report's cover
 * config (models.BoardReport.Subtitle/Confidentiality/ReportOwner, Task 9),
 * threaded down by BoardReportPrint. Each is optional: an empty value renders
 * nothing rather than an empty element, so an unconfigured report still
 * produces a clean cover.
 */
const CoverPage = ({
  title,
  subtitle,
  confidentiality,
  reportOwner,
  period,
  logoUrl,
  generatedAt,
}) => {
  const generatedAtDate = generatedAt ? new Date(generatedAt) : new Date();
  const generatedOn = generatedAtDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="a4-page a4-cover-page">
      <div className="a4-cover-content">
        {confidentiality && (
          <p className="a4-cover-confidentiality">{confidentiality}</p>
        )}
        {logoUrl && <img src={logoUrl} alt="Logo" className="a4-cover-logo" />}
        <h1 className="a4-cover-title">{title}</h1>
        {subtitle && <p className="a4-cover-subtitle">{subtitle}</p>}
        <p className="a4-cover-period">{formatPeriodLabel(period)}</p>
        <dl className="a4-cover-meta">
          {reportOwner && (
            <div className="a4-cover-meta-row">
              <dt>Report owner</dt>
              <dd>{reportOwner}</dd>
            </div>
          )}
          <div className="a4-cover-meta-row">
            <dt>Generated on</dt>
            <dd>{generatedOn}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
};

CoverPage.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  confidentiality: PropTypes.string,
  reportOwner: PropTypes.string,
  period: PropTypes.string,
  logoUrl: PropTypes.string,
  generatedAt: PropTypes.string,
};

export default CoverPage;
